import { CancelIcon } from './CancelIcon';

/**
 * author: Google
 * id 02F70DD2-E16E-43FD-9C2A-267C965E3919
 * name cancel
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cancel.svg
 * tags
 */
export const DoNotDisturbAltIcon = CancelIcon;
export default DoNotDisturbAltIcon